import { render, staticRenderFns } from "./KpiManagement.vue?vue&type=template&id=6cf58021&"
import script from "./KpiManagement.vue?vue&type=script&lang=js&"
export * from "./KpiManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports